import './sticky-contact.scss';
import stickyContact from './sticky-contact.js';

export default stickyContact;